import styled from 'styled-components';

export const Wrapper = styled.nav`
	font-family: Comfortaa, sans-serif;
`;

export const MenuList = styled.ul`
	display: flex;
	justify-content: space-between;
	margin: 0;
	padding: 0;
	font-size: 1em;
	text-decoration: none;
	list-style: none;
`;

export const MenuItem = styled.li`
	position: relative;
	flex: 1;

	/* podświetlenie pozycji menu – działa dla WSZYSTKICH */
	&:hover {
		background: ${({ theme }) => theme.background.transparentDropdown};
	}

	/* a tu tylko rozwijamy dropdown, jeśli w ogóle jest ul w środku */
	&:hover > ul {
		display: block;
		visibility: visible;
		opacity: 1;
	}
`;


export const MenuHeader = styled.span`
	display: block;
	padding: 1.5em 0;
	color: ${({ theme }) => theme.color.dark};
	text-align: center;
	text-transform: lowercase;
	text-decoration: none;
`;
